import { IConnectedDevice } from '../types/IConnectedDevice';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetUserConnectedDevicesParams {
  userId: string;
}

export interface IGetUserConnectedDevicesResult extends IGetItemsResult {
  devices: IConnectedDevice[];
}

export class GetUserConnectedDevicesRequest extends Request<IGetUserConnectedDevicesParams, IGetUserConnectedDevicesResult> {
  constructor(params: IGetUserConnectedDevicesParams) {
    super('getUserConnectedDevices', params);
  }
}
